<template>
  <div class="announcements">
    <vue-headful title="Neuigkeiten - FF Pfaffenhofen"/>
    <Header :menu-at="0" headerTitle="Neuigkeiten und Aktuelles"/>

    <div class="container">
      <span class="large-icon">
        <font-awesome-icon icon="newspaper" />
      </span>
      <div class="header-container">
         <h1>Neuigkeiten und Aktuelles</h1>
        <p>Hier finden Sie eine Übersicht über aktuelle Termine und Neuigkeiten über die Freiwillige Feuerwehr Pfaffenhofen.</p>
      </div>
     
      <div class="create-box" v-if="userID">
        <button class="btn-default" @click="createShow()">
          <font-awesome-icon icon="plus-circle" />
          Neue Ankündigung</button>
      </div>
    </div>


    <div class="content">
      <div class="container">
        <div class="post-container" v-infinite-scroll="loadMore" infinite-scroll-disabled="busy" infinite-scroll-distance="10">
          <div class="announcement" v-for="(data, index) in announcements" :key="data.id">
            <div class="show-year" v-if="data.createdShow">
              <p class="year">Das Jahr <span class="highlight">{{ data.createdYear }}</span> im Überblick:</p>
              <div class="divider"></div>
            </div>
            <div class="post">
              <!-- Controll Buttons -->
              <div class="post-options">
                <div>
                  <button @click="togglePost(index)" title="Mehr Anzeigen" v-if="!data.show"> 
                    <font-awesome-icon icon="plus" />
                  </button>
                  <button @click="togglePost(index)" title="Weniger Anzeigen" v-else> 
                    <font-awesome-icon icon="minus" />
                  </button>
                </div> 
                <div v-if="$session.get('userID')" v-show="data.show">
                  <button @click="appendShow(data.id, index)" title="Datei hochladen"> 
                    <font-awesome-icon icon="file-upload" />
                  </button>
                  <div class="seperator"></div>
                  <button @click="editShow(data.id, index)" title="Bearbeiten">
                    <font-awesome-icon icon="cog" />
                  </button>
                  <button class="post-delete" @click="removeShow(data.id, index)" title="Löschen">
                    <font-awesome-icon icon="trash" />
                  </button>
                </div>
              </div>

              <!-- Content -->
              <div class="post-content">
                <p class="post-category" v-show="data.show">
                  <font-awesome-icon icon="tags" v-if="data.category"></font-awesome-icon>
                  {{ data.category }}</p>
                <h1 class="post-title" @click="togglePost(index)">{{ data.title }}</h1>
                <p class="post-info">
                  <span class="post-author">
                    <font-awesome-icon icon="user" />
                    {{ data.creator }}
                  </span>
                  <span class="post-time">
                    <font-awesome-icon icon="clock" /> 
                    {{ data.time }}
                  </span>
                </p>
                <p class="post-body" v-html="data.description" v-show="data.show"></p>

                <!-- Documents (if available) -->
                <div class="post-documents" v-if="data['document_files'].length > 0" v-show="data.show">
                  <h1>Dokumente</h1>
                  <div v-for="(doc, attIdx) in data['document_files']" :key="doc['file_id']">
                    <div class="entry">
                      <a :href="doc.file_url"> 
                        <font-awesome-icon icon="file-pdf" />
                        {{ doc.file_name }}
                        </a>  
                        <button class="btn-default" @click="removeAttachment(doc.file_id, index, attIdx)" title="Dokument löschen"
                          v-if="$session.get('userID') && $session.get('userID') == data.creatorID">
                          <font-awesome-icon icon="trash" />
                        </button>
                    </div>
                  </div>
                </div>

                <!-- Images (if available) -->
                <div class="post-images" v-if="data['image_files'].length > 0 && data.show">
                  <h1>Bilder</h1>
                  <div class="flex-row">
                    <div class="image" v-for="(image, imgIdx) in data['image_files']" :key="image['file_id']">
                      <img :src="image.thumb_url" @click="openGallerty(index, imgIdx)" />
                      <div class="btn-group" v-if="$session.get('userID') && $session.get('userID') == data.creatorID">
                        <div class="center-buttons">
                          <button class="btn-option" @click="openGallerty(index, imgIdx)" title="Vergrößern">
                            <font-awesome-icon icon="expand" />
                            </button>
                          <button class="btn-option" @click="removeImage(image.file_id, index, imgIdx)" title="Bild löschen">
                            <font-awesome-icon icon="trash" />
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>  
                  <LightBox :images="data['lightbox_data']" :ref="'lightbox' + index" :show-caption="true" :show-light-box="false"></LightBox>
                </div>
              </div>
            </div>
          </div>
          
          <div class="announcement" v-if="reachedEnd">
            <div class="post">
              <div class="post-content">
                <h1 class="post-title">Ende</h1>
                <p class="post-body">Keine weiteren Einträge vorhanden.</p>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <Footer />

    <modal name="create-modal" :pivotY=0.2 height="auto" :adaptive="true" :clickToClose="false">
      <div class="create-modal modal">
        <h1>Neuen Ankündigung</h1>
        <p>Legen Sie neue Einträge über das folgende Formular an.</p>
        <form @submit.prevent="createSubmit()">
          <label for="title">Titel <span class="required">*</span></label>
          <div class="input-row">
            <span class="input-icon">
              <font-awesome-icon icon="heading"/>
            </span>
            <input type="text" placeholder="Titel"  v-model="createData.title"/>
          </div>
          <p class="input-error" v-if="createData.errorTitle">Feld muss ausgefüllt werden.</p>

          <label for="title">Kategorie</label>
          <div class="input-row">
            <span class="input-icon">
              <font-awesome-icon icon="tags"/>
            </span>
            <input type="text" placeholder="Kategorie"  v-model="createData.category"/>
          </div>
          <label for="title">Inhalt <span class="required">*</span></label>
          <wysiwyg v-model="createData.body" placeholder="Text der Ankündigung" />
          <p class="input-error" v-if="createData.errorBody">Feld muss ausgefüllt werden.</p>
          <div class="footer">
            <button class="btn-primary" type="submit">
              <font-awesome-icon icon="plus-circle" />
              Erstellen</button>
            <button class="btn-default" @click="createHide()" type="reset">Abbrechen</button>
          </div>
        </form>
      </div>
    </modal>

    <modal name="edit-modal" :pivotY=0.2 height="auto" :adaptive="true">
      <div class="edit-modal modal">
        <h1>Bearbeiten des Inhaltes</h1>
        <p>Legen Sie neue Einträge über das folgende Formular an.</p>
        <form @submit.prevent="editSubmit()">
          <label for="title">Titel <span class="required">*</span></label>
          <div class="input-row">
            <span class="input-icon">
              <font-awesome-icon icon="heading"/>
            </span>
            <input type="text" placeholder="Titel"  v-model="editData.title"/>
          </div>
          <p class="input-error" v-if="editData.errorTitle">Feld muss ausgefüllt werden.</p>

          <label for="title">Kategorie</label>
          <div class="input-row">
            <span class="input-icon">
              <font-awesome-icon icon="tags"/>
            </span>
            <input type="text" placeholder="Kategorie"  v-model="editData.category"/>
          </div>
          <label for="title">Inhalt <span class="required">*</span></label>
          <wysiwyg v-model="editData.body" placeholder="Text der Ankündigung"/>
            <p class="input-error" v-if="editData.errorBody">Feld muss ausgefüllt werden.</p>
          <div class="footer">
            <button class="btn-primary" @click="editSubmit()" type="submit">
              <font-awesome-icon icon="cog"/>
              Bearbeiten</button>
            <button class="btn-default" @click="editHide()" type="reset">Abbrechen</button>
          </div>
        </form>
      </div>
    </modal>

    <modal name="delete-modal" :pivotY=0.2 height="auto" :adaptive="true">
      <div class="delete-modal modal">
        <h1>Wirklich Löschen?</h1>
        <p>
          Sind Sie sicher das sie den Eintrag wirklich löschen wollen. <br>
          Gelöschte Einträge kommen nicht wiederhergestellt werden.           
        </p>
        <div class="footer">
          <button class="btn-primary" @click="removeSubmit()">
            <font-awesome-icon icon="trash"/>
            Löschen</button>
          <button class="btn-default" @click="removeHide()">Abbrechen</button>
        </div>
      </div>
    </modal>

    <modal name="append-modal" :pivotY=0.2 height="auto" :adaptive="true" :clickToClose="false">
      <div class="append-modal modal">
        <h1>Dateien hochladen</h1>
        <p>
          Fügen Sie Einträgen PDF- oder Bild-Dateien hinzu.          
        </p>
        <label for="files">Dateien</label>
        <vue-dropzone ref="vueDropzone" id="dropzone" :options="dropzoneOptions"></vue-dropzone>
        <div class="footer">
          <button class="btn-primary" @click="appendSubmit()">
            <font-awesome-icon icon="file-upload"/>
            Fertig</button>
          <button class="btn-default" @click="appendHide()">Abbrechen</button>
        </div>
      </div>
    </modal>

  </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import LightBox from 'vue-image-lightbox'
import { EventBus } from '../event-bus.js'

export default {
  name: 'announcements',
  components: {
    Header, LightBox, Footer,
    vueDropzone: vue2Dropzone
  },
  data: () => {
    return {
      userID: "",
      announcements: [],
      selectedID: "",
      selectedIndex: "",
      busy: true,
      activeOption: 0,
      reachedEnd: false,
      lastCreated: "",
      createData: {
        title: "",
        category: "",
        body: "",
        errorTitle: false,
        errorBody: false
      },
      editData: {
        title: "",
        category: "",
        body: "",
        id: "",
        errorTitle: false,
        errorBody: false
      },
      dropzoneOptions: {
          url: 'https://ff-pfaffenhofen.de/api/v1/announcements/create/file',
          resizeWidth: 1024,
          acceptedFiles: '.jpg,.jpeg,.png,.pdf',
          maxFilesize: 20,
          params: {
            annID: 1
          }
      }
    }
  },
  mounted() {
    this.userID = this.$session.get("userID")
    this.axios.get('https://ff-pfaffenhofen.de/api/v1/announcements')
      .then( (res) => {
        this.announcements = res["data"]["announcements"]
        this.busy = false

        this.announcements.forEach(element => {
          let createdYear = element.created.substring(0, 4)
          element.createdYear = createdYear

          let showYear = this.lastCreated != createdYear
          element.createdShow = showYear
          this.lastCreated = createdYear
        })
      })

    
    EventBus.$on('logout', () => {
      this.userID = ""
    })

    EventBus.$on('login', (userID) => {
      this.userID = userID
    })

  },
  methods: {
    editShow(id, index) {
      this.selectedID = id
      this.selectedIndex = index
      this.editData.title = this.announcements[index].title
      this.editData.category = this.announcements[index].category
      this.editData.body = this.announcements[index].description
      this.$modal.show('edit-modal')
    },
    editHide() {
        this.$modal.hide('edit-modal')
    },
    editSubmit() {
      this.editData.errorTitle = false
      this.editData.errorBody = false
      let error = false

      if(!this.editData.title) {
        this.editData.errorTitle = true
        error = true
      }

      if(!this.editData.body || this.editData.body == "<br>") {
        this.editData.errorBody = true
        error = true
      }

      if(error) return;

      this.axios.post('https://ff-pfaffenhofen.de/api/v1/announcements/edit', {
        title: this.editData.title,
        body: this.editData.body,
        category: this.editData.category,
        postID: this.selectedID
      }, {withCredentials: true})
      .then(() => {
        this.$modal.hide('edit-modal')
        this.announcements[this.selectedIndex].title = this.editData.title
        this.announcements[this.selectedIndex].category = this.editData.category
        this.announcements[this.selectedIndex].description = this.editData.body
      })

    },
    removeShow(id, index) {
      this.selectedID = id
      this.selectedIndex = index
      this.$modal.show('delete-modal')
    },
    removeHide() {
      this.$modal.hide('delete-modal')
    },
    removeSubmit() {

      this.axios.post('https://ff-pfaffenhofen.de/api/v1/announcements/delete', {
        postID: this.selectedID
      }, {withCredentials: true})
      .then(() => {
        this.$modal.hide('delete-modal')
        this.announcements.splice(this.selectedIndex, 1)
      })

    },
    createShow() {
      this.$modal.show('create-modal')
    },
    createHide() {
      this.$modal.hide('create-modal')
      this.createData.title = ""
      this.createData.category = ""
      this.createData.body = ""
    },
    createSubmit() {
      this.createData.errorTitle = false
      this.createData.errorBody = false
      let error = false

      if(!this.createData.title) {
        this.createData.errorTitle = true
        error = true
      }

      if(!this.createData.body || this.createData.body == "<br>") {
        this.createData.errorBody = true
        error = true
      }

      if(error) return;

      this.axios.post('https://ff-pfaffenhofen.de/api/v1/announcements/create', {
          title: this.createData.title,
          body: this.createData.body,
          category: this.createData.category,
          userID: this.userID
        }, {withCredentials: true})
      .then((response) => {
        this.announcements.unshift(response["data"])
        this.$modal.hide('create-modal')
      })

    },
    loadMore() {
      this.busy = true
      this.axios.get(
        'https://ff-pfaffenhofen.de/api/v1/announcements', {
          params: {
            offset: this.announcements.length
          }
        })
      .then( (res) => {
        let data = res.data.announcements
        data.forEach(announcement => {

          let createdYear = announcement.created.substring(0, 4)
          announcement.createdYear = createdYear

          let showYear = this.lastCreated != createdYear
          announcement.createdShow = showYear

          this.lastCreated = createdYear

          this.announcements.push(announcement)
        });

        if(data.length != 0) {
          this.busy = false
        } else {
          this.reachedEnd = true
        }
      })
      

    },
    appendShow(id, index) {
      this.selectedID = id
      this.selectedIndex = index
      this.dropzoneOptions.params.annID = id
      this.$modal.show('append-modal')
    },
    appendHide() {
      this.$modal.hide('append-modal')
    },
    appendSubmit() {
      this.$modal.hide('append-modal')

      this.userID = this.$session.get("userID")
      this.axios.get('https://ff-pfaffenhofen.de/api/v1/announcements')
        .then( (res) => {
          this.announcements = res["data"]["announcements"]
          this.busy = false
      })
    },
    removeAttachment(id, idx, attIdx) {
      this.axios.post('https://ff-pfaffenhofen.de/api/v1/announcements/delete/file', {
          "id": id
        }, {withCredentials: true})
      .then(() => {
        let docFiles = this.announcements[idx]["document_files"]
        docFiles.splice(attIdx, 1)
      })
    },
    removeImage(id, idx, attIdx) {
      this.axios.post('https://ff-pfaffenhofen.de/api/v1/announcements/delete/file', {
          "id": id
        }, {withCredentials: true})
      .then(() => {
        let imgFiles = this.announcements[idx]["image_files"]
        imgFiles.splice(attIdx, 1)
      })
    },
    openGallerty(idx, imgIdx) {
      const lightbox = this.$refs['lightbox' + idx]
      lightbox[0].showImage(imgIdx)
    },
    togglePost(index) {
      let toggleState = this.announcements[index].show
      this.announcements[index].show = !toggleState
    }
  }
}
</script>

<style scoped lang="scss">
@import "../styles/theme.scss";
@import "~vue-wysiwyg/dist/vueWysiwyg.css";

.content {
  padding-top: 30px;
  min-height: 600px;
  background: $light-1;
}

.header-container {
  margin-left: 115px;
}

.container {
  position: relative;
}

.large-icon {
  position: absolute;
  left: 20px;
  top: 20px;
  font-size: 70px;
  color: $primary-1;
  transform: rotate(30deg);
}


.create-box {
  margin: 50px 0px 20px 0px; 

  .btn-default {
    width: 100%;
    background: $light-0;
    padding: 20px;
    font-size: 18px;
    font-weight: bold;
    border: 2px dashed #b3b3b3;

    transition: 200ms;
    &:hover {
      border: 2px dashed $primary;
      color: $primary;
      transition: 200ms;
    }

    svg {
      color: $primary;
      margin-right: 10px;
    }
  }


}

.announcements {
  padding-top: 50px;

  .container {
    box-sizing: border-box;
  }
}

.post {
  padding-left: 20px;
  background: $light-0;
  margin-bottom: 20px;
  display: flex;
  box-shadow: $shadow-light;
  border: 1px solid lighten($gray-0, 15%);
  border-radius: 6px;

  @include tablet {
    padding-left: 60px;
  }

  .post-options {
    max-width: 60px;
    display: flex;
    flex-direction: column;
    margin-top: 20px;

    @include tablet {
      max-width: 80px;
    }

    .seperator {
      margin: 20px 0px;
    }

    button {
      background: none;
      border: 1px solid #b3b3b3;
      height: 40px;
      width: 40px;
      text-align: center;
      border-radius: 100%;
      margin: 5px 20px 5px 0px;
      background: $light-0;
      cursor: pointer;


      &:hover {
        color: $primary;
        border: 1px solid $primary;
      }
    }
 
  }

  .post-body {
    padding-right: 10px;
  }

  .post-content {
    flex-basis: 100%;
    padding-right: 20px;
  }

  .post-category {
    color: $primary;
    text-transform: uppercase;
    margin-bottom: -5px;
  }

  .post-title {
    color: $dark !important;
    font-weight: bolder;
    opacity: 0.9;
    margin-bottom: 25px;
    font-size: 18px;

    @include tablet {
      font-size: 26px;
    }
  }

  .post-info {
    margin-top: -20px;
  }

  .post-author {
    color: $gray;
  }

  .post-time {
    color: $gray;
    display: block;

    @include tablet {
      margin-left: 20px;
      display: inline;
    }
  }

  .post-footer-seperator {
    border-top: 1px solid $gray;
  }

  .post-documents {
    h1 {
      color: $dark;
      font-size: 16px;
      opacity: 0.9;

      @include tablet {
      font-size: 20px;
    }
    }

    .entry {
      margin: 5px 0px 20px 0px;
      width: 90%;
      background: $light-0;
      padding: 10px;
      box-sizing: border-box;
      box-shadow: 1px 1px 8px rgba(0,0,0,.2);
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
      position: relative;

      @include tablet {
        width: 50%;
      }

      a {
        font-size: 18px;
        text-decoration: none;
        color: $dark;
        width: 100%;

        &:hover {
          color: $primary;
        }
      }

      svg {
        color: $primary;
        margin: 0 10px;
      }

      .btn-default {
        position: absolute;
        right: 0px;
        top: 0px;
        border-left: 1px solid #b3b3b3;
        padding: 12px 12px 13px 12px;

        &:hover {
          background: mix($light-0, $primary, 80%)
        }
      }
    }

  }

  .post-delete {
    margin-bottom: 20px !important;
  }

  .post-images {

    padding-bottom: 20px;

    h1 {
      color: $dark;
      font-size: 22px;
      opacity: 0.9;
    }

    .flex-row {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      align-items: flex-start;
      
      @include tablet {
        margin-left: -1%;
      }

      .image {
        width: 49%;
        margin: 0 0.5% 10px 0.5%;
        position: relative;

        @include tablet {
          width: 31%;
          margin: 0 1% 0 1%;
        }

        @include desktop {
          width: 23%;
        }

        .btn-default {
          position: absolute;
          top: 0px;
          right: 0px;
          background: $light-1;
          height: 40px;
          width: 60px;
          text-align: center;
          border-left: 1px solid $gray;
          border-bottom: 1px solid $gray;

          &:hover {
            background: mix($light-1, $primary, 80%);
            color: $primary;
          }
        }

      }

      .btn-group {
        position: absolute;
        top: 0; 
        left: 0;
        width: 100%;
        height: 98%;
        opacity: 0.5;

        &:hover {
          background: rgba(0,0,0,0.5);
          opacity: 1;
        }
      }

      .center-buttons {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;

        button {
          background: none;
          border: none;
          color: $light-0;
          font-size: 32px;
          width: 80px;
          cursor: pointer;

          &:hover {
            color: lighten($primary, 20%);
          }
        }
      }

      img {
        width: 100%;
        height: 100%;
        cursor: pointer;
      }

    }
  }

}

#dropzone {
  overflow: auto;
  white-space: nowrap;
}

.modal {
  padding: 10px 30px;
  h1 {
    color: $primary;
  }
  p {
    color: lighten($dark, 40);
    font-size: 14px;
  }
  .footer {
    margin: 60px 0px 20px 0;
    display: flex;
    flex-direction: row-reverse;

    button  {
      font-size: 18px;
      font-weight: bold;
      margin-left: 12px;
    }
    .btn-default {
      color: lighten($dark, 40);

      &:hover {
        color: $dark;
      }
    }
    .btn-primary {
      color: desaturate($primary, 40);

      &:hover {
        color: $primary;
      }
    }
  }

  label {
    color: $dark;
    font-weight: bolder;

    .required {
      color: $primary;
    }
  }

  .input-row {
    margin: 4px 0px 12px 0px;
    display: flex;
  }

  .input-icon {
    background: lighten($gray, 48);
    color: lighten($dark, 12);
    
    border: 1px solid #e4e4e4;
    border-right: none;
    padding: 8px 14px;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  input {
    flex-grow: 1;
    border: 0px;
    padding: 0px 12px;
    border: 1px solid #e4e4e4;
    font-size: 16px;

    &:focus, &:active {
      box-shadow: 0px 0px 4px $primary;
    }
  }

  .input-error {
    color: $primary;
    margin-top: -6px;
  }
}

.show-year {
  .year {
    color: $dark;
    font-size: 22px;
    font-weight: 800;

    .highlight {
      color: $primary-0;
    }
  }

  .divider {
    height: 2px;
    width: 100%;
    background: $dark;
    margin: -15px 0px 10px 0px;
    opacity: 0.5;

    @include desktop {
      width: 400px;
    }
  }
}

</style>



